import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-67" data-mp="26ll08frx8f20">
      <div className="mx-auto max-w-4xl" data-id="element-68" data-mp="26k03qkm1qm1i">
        <h2 className="text-center font-display text-[26px] leading-tight font-black tracking-tight text-navy sm:text-4xl" data-id="element-69" data-mp="22lkdm7uo4xjv">
          De la duda silenciosa… a la{' '}
          <span className="italic text-brandred" data-id="element-70" data-mp="2ubxf6all3c23">certeza inmediata</span> en cada decisión clínica
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy/65" data-id="element-71" data-mp="2qa3lwndpxaby">
          El problema nunca ha sido tu conocimiento. El problema es que nadie te enseñó cómo decidir
          bajo presión real.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-72" data-mp="1ewrmqpswlfw4">
          {/* ANTES */}
          <div className="rounded-3xl border border-navy/10 bg-white p-5 sm:p-6" data-id="element-73" data-mp="19v28l1adwm3t">
            <div className="flex items-center gap-2" data-id="element-74" data-mp="174ufydkk4ixf">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy/10 text-navy" data-id="element-75" data-mp="1739mkr9zb615">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-76" data-mp="1c231mo4wz53f" />
              </span>
              <h3 className="font-display text-xl font-black tracking-tight text-navy" data-id="element-77" data-mp="y4ejho28ec22">Antes</h3>
            </div>
            <ul className="mt-4 space-y-3" data-id="element-78" data-mp="135loxggwiz5k">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-79" data-mp="ocrxcwocuskj">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/35" strokeWidth={3} aria-hidden data-id="element-80" data-mp="t6mq0plxuhvr" />
                  <span className="text-[14px] leading-snug text-navy/60" data-id="element-81" data-mp="jf9zq2fsfzru">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* DESPUÉS */}
          <div className="rounded-3xl border-2 border-brandred/30 bg-white p-5 shadow-[0_10px_40px_-20px_rgba(200,16,46,0.5)] sm:p-6" data-id="element-82" data-mp="af3m8gk3azso">
            <div className="flex items-center gap-2" data-id="element-83" data-mp="2c5auti7090dt">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brandred text-white" data-id="element-84" data-mp="27dkhd3crtwi6">
                <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-85" data-mp="23bpgu12nzn5g" />
              </span>
              <h3 className="font-display text-xl font-black leading-tight tracking-tight text-navy" data-id="element-86" data-mp="239l6p1e69rwq">
                Con Ruta Anticoagulación™
              </h3>
            </div>
            <ul className="mt-4 space-y-3" data-id="element-87" data-mp="2v2c0l58dv4it">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-88" data-mp="2r21pje5qhnx3">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandred" strokeWidth={3} aria-hidden data-id="element-89" data-mp="2m1xcxz7y5dc5" />
                  <span className="text-[14px] font-medium leading-snug text-navy" data-id="element-90" data-mp="1an0fc0xp5ft6">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <TransformCTA text="Quiero pasar de la duda a la certeza clínica hoy" data-id="element-91" data-mp="15qjo2xv7albv" />
      </div>
    </section>;
}